var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.data, function(item, index) {
      return _c(
        "v-list-tile",
        { key: index },
        [
          _c(
            "v-list-tile-content",
            [
              _c("v-list-tile-title", [
                _vm._v("\n        " + _vm._s(item.label) + "\n      ")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-tile-action",
            [
              _c("v-list-tile-action-text", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("digitGrouping")(item.value, (_vm.trun = true))
                    ) +
                    "\n      "
                )
              ])
            ],
            1
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-206f7eac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206f7eac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FactSheet_GeneralInfo.vue
// module id = null
// module chunks = 